// ============================================================================
// CASE COURT DETAIL ENDPOINTS — ADR-0001
// ============================================================================
// Backend: CaseCourtDetailController → /api/v1/CaseCourtDetail.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_COURT_DETAIL_BASE_PATH = '/CaseCourtDetail';

export const caseCourtDetailEndpoints = {
  byCase: (caseId: ID) =>
    buildEndpointWithParams(`${CASE_COURT_DETAIL_BASE_PATH}/by-case/:caseId`, { caseId }),
  save: () => buildEndpoint(CASE_COURT_DETAIL_BASE_PATH),
} as const;

export default caseCourtDetailEndpoints;
